const { default: Workflow } = require('../../models/workflow');
const { default: JobType } = require('../../models/jobType');
const { default: TaskType } = require('../../models/taskType');
const { default: Job } = require('../../models/job');

let settings = require('@/classes/settings');
const { baseTimeFields } = require('@/classes/timeFields');

// Datumvelden voor de tijds-widget-veldkiezer op de taken-overzichten
// (workflows-overzicht én TAKEN-tab), zodat beide consistent blijven.
const jobTimeFields = [
    { value: 'createdAt', label: 'Aanmaakdatum', description: 'Datum waarop de workflow werd aangemaakt' },
    { value: 'updatedAt', label: 'Aanpassingsdatum', description: 'Datum van de laatste wijziging' },
    { value: 'dueAfterDate', label: 'Planningsdatum', description: 'Ingeplande datum (zoals in de Planning-kolom)' },
    { value: 'dueRequestDate', label: 'Gewenste planningsdatum', description: 'Door de aanvrager gewenste datum' },
];

const taskTimeFields = [
    ...jobTimeFields,
    ...[{ value: 'responseReportedAt', label: 'Uitvoeringsdatum', description: 'Datum waarop de taak is uitgevoerd/gerapporteerd' }],
];

module.exports = {
    routes: [{
        path: '/tasks',
        name: 'tasks',
        meta: {
            permissions: ['tasks.workflows.read', 'tasks.jobs.read', 'tasks.planning.read']
        },
        redirect: { name: 'tasks.overview' }
    },
    {
        path: '/tasks/jobs',
        name: 'tasks.jobs',
        meta: {
            permissions: ['tasks.jobs.read']
        },
        component: () => import('./views/jobs.vue')
    },
    {
        path: '/tasks/overview/:id?',
        name: 'tasks.overview',
        meta: {
            permissions: ['tasks.workflows.read']
        },
        component: () => import('./views/index.vue')
    },
    {
        path: '/tasks/planning',
        name: 'tasks.planning',
        meta: {
            permissions: ['tasks.planning.read']
        },
        component: () => import('./views/planning.vue')
    },
    {
        path: '/tasks/routes',
        name: 'tasks.routes',
        meta: {
            permissions: ['routes.read']
        },
        component: () => import('./views/routes.vue')
    },
    {
        path: '/tasks/workflows',
        name: 'taskWorkflows',
        meta: {
            permissions: ['tasktypes.read']
        },
        component: () => import('./workflows/index.vue')
    },
    {
        path: '/tasks/workflows/detail/:id?',
        name: 'taskWorkflow',
        meta: {
            permissions: ['tasktypes.create', 'tasktypes.update']
        },
        component: () => import('./workflows/detail.vue')
    },
    {
        path: '/tasks/jobtypes',
        name: 'jobTypes',
        meta: {
            permissions: ['jobtypes.read']
        },
        component: () => import('./jobtypes/index.vue')
    },
    {
        path: '/tasks/jobtypes/detail/:id?',
        name: 'taskForm',
        meta: {
            permissions: ['jobtypes.create', 'jobtypes.update']
        },
        component: () => import('./jobtypes/detail.vue')
    },
    {
        path: '/tasks/response/:id?',
        name: 'response',
        component: () => import('./responses/detail.vue')
    }
    ],
    objectType: 'TASK',
    search: Workflow.searchConfig,
    planning: {
        users: {
            search: [
                /*{
                    'icon': 'mdi-account-outline',
                    'label': 'Gebruiker',
                    'type': 'module',
                    'settings': {
                        'module': 'searchUsers',
                        'fields': ['firstName', 'lastName'],
                        'title': '{firstName} {lastName}',
                        'options': {
                            enabled: true
                        }
                    },
                    'filter': 'id'
                },*/
                {
                    icon: 'mdi-account-group-outline',
                    label: 'Team',
                    type: 'relation',
                    settings: {
                        id: 'id',
                        module: "groups",
                        fields: ['name'],
                        title: '{name}',
                    },
                    filter: 'groups'
                },
            ]
        },
        projects: {
            search: [{
                'icon': 'mdi-format-text',
                'label': 'Naam',
                'type': 'property',
                'filter': 'name'
            },
            {
                'icon': 'mdi-format-text',
                'label': 'Omschrijving',
                'type': 'property',
                'filter': 'description'
            },
            {
                'icon': 'mdi-office-building-outline',
                'label': 'Bedrijf',
                'type': 'module',
                'settings': {
                    'module': 'companies',
                    'fields': ['name'],
                    'title': '{name}',
                },

                'filter': 'companyId'
            }
            ]
        }
    },
    calendar: [
        {
            'icon': 'mdi-clipboard-outline',
            'label': 'Workflow',
            'type': 'module',
            'settings': {
                'module': 'taskTypes',
                'fields': ['name'],
                'title': '{name}',
            },
            'filter': 'taskTypeId'
        },
        {
            'icon': 'mdi-folder-open-outline',
            'label': 'Project',
            'type': 'module',
            'settings': {
                'module': 'projects',
                'fields': ['name', 'description'],
                'title': '{name} ({description})',
            },

            'filter': 'projectId'
        },
        {
            'icon': 'mdi-file-sign',
            'label': 'Dienst',
            'type': 'module',
            'settings': {
                'module': 'services',
                'fields': ['name'],
                'title': '{name}',
            },

            'filter': 'serviceId'
        },
        {
            'icon': 'mdi-office-building-outline',
            'label': 'Bedrijf',
            'type': 'module',
            'settings': {
                'module': 'companies',
                'fields': ['name', 'description'],
                'title': '{name} ({description})',
            },

            'filter': 'companyId'
        },
        {
            'icon': 'mdi-tag-outline',
            'label': 'Status',
            'type': 'options',
            'settings': {
                'options': () => {
                    let statusCodes = [];
                    for (let i = 0; i < settings.statusCodes.length; i++) {
                        const statusCode = settings.statusCodes[i];
                        if (statusCode.job_enabled || statusCode.value == 'done') {
                            statusCodes.push(statusCode);
                        }
                    }
                    return statusCodes;
                }
            },
            'filter': 'statusCode'
        },
        {
            'icon': 'mdi-account-outline',
            'label': 'Verantwoordelijke',
            'type': 'relation',
            'settings': {
                'module': 'searchUsers',
                'fields': ['firstName', 'lastName', 'username'],
                'title': '{firstName} {lastName} ({username})',
                'options': {
                    enabled: true
                }
            },
            'filter': 'responsibleUsers'
        },
    ],
    detail: {
        route: 'task',
        endpoint: 'task',
        objectName: 'Task',
        fields: ['id', 'name', 'description', 'statusCode', 'dueBeforeDate', 'dueAfterDate', 'completedDate', 'dueRequestDate', 'postalCode', 'company{id}', 'taskType{id}', 'service{id}', 'project{id}', 'storageObjects{ id isActive key name product{id name} project{id name} company{id name} service{id name} serviceType{id name} task{id name} taskType{id name} measurementType{id name} type tags{id name}}', 'users{id username firstName lastName assignedRealmRoles{name}}'],
        tabs: [{
            tab: 'general',
            text: 'Algemeen'
        }, {
            tab: 'storageobjects',
            text: 'Media'
        }]
    },
    index: {
        route: 'tasks',
        endpoint: 'tasks',
        // Tijds-widget met datumveld-keuze (rechts), standaard "Altijd".
        defaultTimeField: 'createdAt',
        timeFields: taskTimeFields,
        fields: ['id', 'name', 'isJobActive', 'stepName', 'stepType', 'integrationIds{integrationName, integrationId}', 'stepId', 'description', 'isCompleted', 'responseReportedAt', 'postalCode', 'parent{id}', 'taskType{id name}', 'templates{id type object content}', 'company{id name}', 'project{id name description}', 'children{id stepType statusCode responses{id} category}', 'service{id name periodicityCode}', 'statusCode', 'dueRequestDate', 'dueAfterDate', 'dueBeforeDate', 'createdAt', 'updatedAt'],
        headers: [
            {
                text: '',
                width: 30,
                value: 'expand',
                component: () => import('@/components/columns/eod-column-expand-icon.vue'),
                extra: {
                    inset(item) {
                        if (item.parent && item.parent.id) {
                            return 12;
                        }

                        return 0;
                    }
                }
            },
            {
                text: 'Naam',
                value: 'name',
                extra: {
                    chars: 60,
                    description: {
                        value: 'description',
                    }
                },
                component: () => import('@/components/columns/eod-column-edit.vue')
            },
            {
                text: 'Huidige stap',
                value: 'currentStep',
                sortable: false,
                width: 180,
                component: () => import('@/components/columns/eod-column-workflow-step.vue')
            },
            {
                text: 'Postcode',
                value: 'postalCode',
                width: 100,
                component: () => import('@/components/columns/eod-column-edit.vue')
            },
            {
                text: 'Planningsdatum',
                value: 'dueAfterDate',
                sortable: true,
                component: () => import('@/components/columns/eod-column-planning.vue'),
                extra: {
                    icon: 'mdi-calendar',
                    collapsed: false,
                }
            },
            {
                text: 'Project',
                value: 'project',
                sortable: false,
                component: () => import('@/components/columns/eod-column-project.vue'),
                extra: {
                    icon: 'mdi-folder-open-outline',
                    collapsed: false,
                }
            },
            {
                text: 'Bedrijf',
                value: 'company',
                sortable: false,
                component: () => import('@/components/columns/eod-column-company.vue'),
                extra: {
                    icon: 'mdi-office-building-outline',
                    collapsed: false,
                }
            },
            {
                text: 'Dienst',
                value: 'service',
                sortable: false,
                component: () => import('@/components/columns/eod-column-service.vue'),
                extra: {
                    icon: 'mdi-file-sign',
                    collapsed: false,
                }
            },
            {
                text: 'Status',
                value: 'statusCode',
                sortable: true,
                width: 160,
                component: () => import('@/components/columns/eod-column-status-code.vue'),
                extra: {
                    readonly: true,
                }
            },
            {
                text: 'Aanpassingsdatum',
                width: 50,
                value: 'updatedAt',
                component: () => import('./../default/columns/date.vue'),
                extra: {
                    icon: 'mdi-alarm',
                    collapsed: true,
                    prepend: 'Gewijzigd op'
                }
            },
            {
                text: 'Aanmaakdatum',
                width: 50,
                value: 'createdAt',
                defaultHidden: true,
                component: () => import('./../default/columns/date.vue'),
                extra: {
                    icon: 'mdi-alarm-plus',
                    collapsed: true,
                    prepend: 'Aangemaakt op'
                }
            },
            {
                text: 'Gewenste planningsdatum',
                width: 50,
                value: 'dueRequestDate',
                defaultHidden: true,
                component: () => import('./../default/columns/date.vue'),
                extra: {
                    icon: 'mdi-calendar',
                    collapsed: true,
                    prepend: 'Gewenste planning'
                }
            },
            {
                text: 'Uitvoeringsdatum',
                width: 50,
                value: 'responseReportedAt',
                component: () => import('./../default/columns/date.vue'),
                extra: {
                    icon: 'mdi-clock-check-outline',
                    collapsed: false,
                    prepend: 'Uitgevoerd op'
                }
            },
            {
                draggable: false,
                value: 'actions',
                width: 100,
                sortable: false,
                component: () => import('./columns/actions.vue')
            }
        ],
        expanded: {
            component: () => import('./rows/jobs.vue')
        },
        tabs: [],
        picklist: false
    },
    jobs: {
        objectType: 'JOB',
        searchTemplateType: 'JOB_FILTER',
        search: Job.searchConfig,
        itemObject: Job,
        index: {
            filterName: 'jobs',
            route: 'jobs',
            endpoint: 'jobs',
            defaultTimeField: 'createdAt',
            timeFields: jobTimeFields,
            fields: ['id', 'name', 'isJobActive', 'stepName', 'responses{id}', 'stepId', 'parent{id name postalCode templates{id name content type object}}', 'company{id name} project{id name} service{id name}', 'description', 'isCompleted', 'company{id name}', 'project{id name description}', 'service{id name periodicityCode}', 'taskType{id name}', 'statusCode', 'dueRequestDate', 'dueAfterDate', 'dueBeforeDate', 'createdAt', 'updatedAt', 'responsibleUsers{id}', 'responsibleGroup{id name}'],
            headers: [
                {
                    text: 'Naam',
                    value: 'parent.name',
                    sortable: false,
                    extra: {
                        chars: 60,
                        description: {
                            value: 'description',
                            /*extra: {
                                chars: 100
                            }*/
                        }
                    },
                    component: () => import('@/components/columns/eod-column-edit.vue')
                },
                {
                    text: 'Huidige stap',
                    value: 'stepId',
                    sortable: false,
                    component: () => import('@/components/columns/eod-column-workflow-step.vue'),
                    extra: {
                        getTemplates(item) {
                            return item.parent.templates;
                        }
                    }
                },
                {
                    text: 'Team',
                    value: 'responsibleGroup',
                    sortable: false,
                    component: () => import('@/components/columns/eod-column-group.vue'),
                },
                {
                    text: 'Verantwoordelijke(n)',
                    value: 'responsibleUsers',
                    sortable: false,
                    component: () => import('@/components/columns/eod-column-users.vue'),
                },
                {
                    text: 'Postcode',
                    value: 'parent.postalCode',
                    sortable: false,
                    width: 50,
                    component: () => import('@/components/columns/eod-column-edit.vue')
                },
                {
                    text: 'Planningsdatum',
                    value: 'dueAfterDate',

                    component: () => import('@/components/columns/eod-column-planning.vue'),
                    extra: {
                        icon: 'mdi-calendar',
                        collapsed: false,
                        getTemplates(item) {
                            return item.parent.templates;
                        }
                    }
                },
                {
                    text: 'Project',
                    value: 'project',
                    sortable: false,
                    component: () => import('@/components/columns/eod-column-project.vue'),
                    extra: {
                        icon: 'mdi-folder-open-outline',
                        collapsed: false,
                    }
                },
                {
                    text: 'Bedrijf',
                    value: 'company',
                    sortable: false,
                    component: () => import('@/components/columns/eod-column-company.vue'),
                    extra: {
                        icon: 'mdi-office-building-outline',
                        collapsed: false,
                    }
                },
                {
                    text: 'Dienst',
                    value: 'service',
                    sortable: false,
                    component: () => import('@/components/columns/eod-column-service.vue'),
                    extra: {
                        icon: 'mdi-file-sign',
                        collapsed: false,
                    }
                },
                {
                    text: 'Status',
                    value: 'statusCode',
                    sortable: true,
                    width: 160,
                    component: () => import('@/components/columns/eod-column-status-code.vue'),
                    extra: {
                        getStatusCodes(settings) {
                            return settings.statusCodes.filter(item => item.task_enabled);
                        },
                        onChange(eod, item, statusCode) {
                            return eod.save('Task', { id: item.id, statusCode: statusCode });
                        }
                    }
                },
                {
                    text: 'Aanpassingsdatum',
                    width: 50,
                    value: 'updatedAt',
                    component: () => import('./../default/columns/date.vue'),
                    extra: {
                        icon: 'mdi-alarm',
                        collapsed: true,
                        prepend: 'Gewijzigd op'
                    }
                },
                {
                    text: 'Aanmaakdatum',
                    width: 50,
                    value: 'createdAt',
                    defaultHidden: true,
                    component: () => import('./../default/columns/date.vue'),
                    extra: {
                        icon: 'mdi-alarm-plus',
                        collapsed: true,
                        prepend: 'Aangemaakt op'
                    }
                },
                {
                    text: 'Gewenste planningsdatum',
                    width: 50,
                    value: 'dueRequestDate',
                    defaultHidden: true,
                    component: () => import('./../default/columns/date.vue'),
                    extra: {
                        icon: 'mdi-calendar',
                        collapsed: true,
                        prepend: 'Gewenste planning'
                    }
                },
                {
                    text: 'Uitvoeringsdatum',
                    width: 50,
                    value: 'responseReportedAt',
                    defaultHidden: true,
                    component: () => import('./../default/columns/date.vue'),
                    extra: {
                        icon: 'mdi-calendar-check',
                        collapsed: true,
                        prepend: 'Uitgevoerd op'
                    }
                },
                {
                    width: 80,
                    sortable: false,
                    value: 'actions',
                    draggable: false,
                    extra: {
                        hideMobileLink: true,
                        hideDelete: true
                    },
                    component: () => import('./columns/actions.vue')
                }
            ],
            expanded: {
                component: () => import('./rows/responses.vue')
            },
            tabs: [],
            picklist: false,
        }
    },
    export: {
        endpoint: 'tasks',
        fields: ['id', 'name', 'description', 'statusCode', 'createdAt', 'updatedAt', 'project{name}']
    },
    import: {
        endpoint: 'Tasks',
        objectName: 'Task',
        fields: ['id', 'name', 'description', 'statusCode']
    },
    itemObject: Workflow,
    workflows: {
        search: [{
            'icon': 'mdi-format-text',
            'label': 'Naam',
            'type': 'property',
            'filter': 'name'
        }],
        index: {
            defaultTimeField: 'createdAt',
            timeFields: baseTimeFields,
            route: 'taskWorkflows',
            endpoint: 'taskTypes',
            fields: ['id', 'name', 'configuration{version settings{key value label isDefault isRoot}}', 'createdAt', 'updatedAt'],
            headers: [
                {
                    width: 50,
                    sortable: false,
                    value: 'color',
                    component: () => import('./workflows/columns/color.vue')
                },
                {
                    text: 'Naam',
                    value: 'name',
                    extra: {
                        chars: 60,
                        description: {
                            value: 'description',
                        }
                    },
                    component: () => import('@/components/columns/eod-column-link')
                },
                {
                    text: 'Aanmaakdatum',
                    width: 50,
                    value: 'createdAt',
                    component: () => import('./../default/columns/date.vue'),
                    extra: {
                        icon: 'mdi-alarm-plus',
                        collapsed: true,
                        prepend: 'Aangemaakt op'
                    }
                }, {
                    text: 'Aanpassingsdatum',
                    width: 30,
                    value: 'updatedAt',
                    component: () => import('./../default/columns/date.vue'),
                    extra: {
                        icon: 'mdi-alarm',
                        collapsed: true,
                        prepend: 'Gewijzigd op'
                    }
                }, {
                    width: 160,
                    sortable: false,
                    value: 'actions',
                    draggable: false,
                    component: () => import('./workflows/columns/actions.vue')
                }
            ],
            tabs: [],
        },
        itemObject: TaskType,
        detail: {
            route: 'taskWorkflow',
            endpoint: 'taskType',
            objectName: 'TaskType',
            fields: ['id', 'name', 'description', 'estimatedDuration', 'measurementTypes{id name description formConfig{enabled category subCategory}}', 'templates{id name type object content}', 'productTypeConfig{id productType{id} jobType{id} variant}', 'articles{id name quantity articleType{id name}}', 'articleTypes{id name quantity}', 'configuration{version settings{key value label isDefault isRoot}}'],
            tabs: [{
                tab: 'general',
                text: 'Algemeen'
            },
            {
                tab: 'form',
                text: 'Stappen',
            }, {
                tab: 'products',
                text: 'Benodigdheden',
            },
            {
                tab: 'assetTypes',
                text: 'Asset types',
            }
            ],
        },
        export: {
            endpoint: 'taskTypes',
            fields: ['id', 'name', 'description']
        },
        import: {
            endpoint: 'taskTypes',
            objectName: 'TaskType',
        },

    },
    jobtypes: {
        search: [{
            'icon': 'mdi-format-text',
            'label': 'Naam',
            'type': 'property',
            'filter': 'name'
        },],
        index: {
            defaultTimeField: 'createdAt',
            timeFields: baseTimeFields,
            route: 'jobTypes',
            endpoint: 'jobTypes',
            fields: ['id', 'name', 'defaultProject{id name}', 'defaultService{id name}', 'createdAt', 'updatedAt', 'configuration{version settings{key value label isDefault isRoot}}'],
            headers: [{
                width: 50,
                sortable: false,
                value: 'color',
                component: () => import('./jobtypes/columns/color.vue')
            },
            {
                text: 'Naam',
                value: 'name',
                extra: {
                    description: {
                        value: 'description',
                        extra: {
                            chars: 100
                        }
                    }
                },
                component: () => import('@/components/columns/eod-column-link')
            },
            {
                text: 'Standaard project',
                value: 'defaultProject.name',
                sortable: false,
                component: () => import('@/components/columns/eod-column-link')
            },
            {
                text: 'Standaard dienst',
                value: 'defaultService.name',
                sortable: false,
                component: () => import('@/components/columns/eod-column-link')
            },
            {
                text: 'Aanmaakdatum',
                width: 50,
                value: 'createdAt',
                component: () => import('./../default/columns/date.vue'),
                extra: {
                    icon: 'mdi-alarm-plus',
                    collapsed: true,
                    prepend: 'Aangemaakt op'
                }
            }, {
                text: 'Aanpassingsdatum',
                width: 50,
                value: 'updatedAt',
                component: () => import('./../default/columns/date.vue'),
                extra: {
                    icon: 'mdi-alarm',
                    collapsed: true,
                    prepend: 'Gewijzigd op'
                }
            }, {
                width: 160,
                sortable: false,
                value: 'actions',
                draggable: false,
                component: () => import('./jobtypes/columns/actions'),
                extra: {
                    permissions: {
                        update: 'jobtypes.update',
                        delete: 'jobtypes.delete'
                    }
                }
            }
            ],
            tabs: [],
        },
        itemObject: JobType,
        detail: {
            route: 'taskForm',
            endpoint: 'jobType',
            objectName: 'JobType',
            fields: ['id', 'formTemplate{id name content type object}', 'name', 'description', 'reportConfig', 'isConnectable', 'connectableConfig{content}', 'skills{id name threshold}', 'defaultProject{id}', 'defaultService{id}', 'measurementTypes{id name description formConfig{enabled category subCategory}}', 'articles{id name quantity articleType{id name}}', 'articleTypes{id name quantity}', 'configuration{version settings{key value label isDefault isRoot}}'],
            tabs: [{
                tab: 'general',
                text: 'Algemeen'
            },
            {
                tab: 'products',
                text: 'Benodigdheden',
                visible(item, eod) {
                    return eod.getUser().can('products.articles.menu')
                }
            },
            {
                tab: 'form',
                text: 'Formulier',
            },
            {
                tab: 'report',
                text: 'Rapport',
            }
            ],
        },
        export: {
            endpoint: 'jobTypes',
            fields: ['id', 'name', 'description']
        },
        import: {
            endpoint: 'jobTypes',
            objectName: 'JobType',
        },

    }
}